import { gql } from '@apollo/client';

export const LOGOUT_USER = gql`
  mutation logout {
    logout {
      message
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query User {
    user {
      id
      email
      profileImage
      firstName
      lastName
    }
  }
`;

export const GET_SIGNED_URL = gql`
  query GetProfileImageUploadSignedUrl(
    $data: GetProfileImageUploadSignedUrlInput!
  ) {
    getProfileImageUploadSignedUrl(data: $data) {
      key
      signedUrl
    }
  }
`;

export const GET_CSV_UPLOAD_SIGNED_URL = gql`
  query GetCsvUploadSignedUrl($data: GetCsvUploadSignedUrlInput!) {
    getCsvUploadSignedUrl(data: $data) {
      key
      signedUrl
    }
  }
`;
